export default __webpack_public_path__ + "static/media/single-value.414fccab.svg";